const $ = require('jquery');
global.$ = global.jQuery = $;

require('bootstrap/dist/css/bootstrap.min.css');
const bootstrap = require('bootstrap');
global.bootstrap = bootstrap;
